export default function setAnimatedSlideshow() {
  const sections = document.querySelectorAll('[data-hover-slider]');

  sections.forEach((section) => {
    const titles = Array.from(section.querySelectorAll('[data-hover-title]'));
    const images = Array.from(section.querySelectorAll('[data-hover-image]'));

    if (!titles.length || !images.length) {
      return;
    }

    titles.forEach((titleElement) => {
      const rawText = titleElement.dataset.slideText || titleElement.textContent || '';
      titleElement.textContent = '';

      rawText.split('').forEach((char, charIndex) => {
        const charWrap = document.createElement('span');
        charWrap.className = 'hover-slider__char';

        const baseLayer = document.createElement('span');
        baseLayer.className = 'hover-slider__char-layer hover-slider__char-layer--base';

        const activeLayer = document.createElement('span');
        activeLayer.className = 'hover-slider__char-layer hover-slider__char-layer--active';

        const printChar = char === ' ' ? '\u00A0' : char;

        baseLayer.textContent = printChar;
        activeLayer.textContent = printChar;

        const delay = `${charIndex * 25}ms`;
        baseLayer.style.setProperty('--char-delay', delay);
        activeLayer.style.setProperty('--char-delay', delay);

        charWrap.appendChild(baseLayer);
        charWrap.appendChild(activeLayer);

        titleElement.appendChild(charWrap);
      });
    });

    const setActiveSlide = (index) => {
      titles.forEach((title) => {
        const isActive = Number(title.dataset.slideIndex) === index;
        title.classList.toggle('is-active', isActive);
        title.setAttribute('aria-selected', String(isActive));
      });

      images.forEach((image) => {
        const isActive = Number(image.dataset.slideIndex) === index;
        image.classList.toggle('is-active', isActive);
      });
    };

    titles.forEach((title) => {
      const index = Number(title.dataset.slideIndex || 0);

      title.addEventListener('mouseenter', () => setActiveSlide(index));
      title.addEventListener('focus', () => setActiveSlide(index));
      title.addEventListener('click', () => setActiveSlide(index));
    });

    setActiveSlide(0);
  });
}
